(function () {
  const sections = document.querySelectorAll('[data-icons-with-text]');

  if (!sections.length) {
    return;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  sections.forEach((section) => {
    section.classList.add('iwt-js');

    const items = section.querySelectorAll('[data-iwt-reveal]');

    if (!('IntersectionObserver' in window) || reduceMotion.matches) {
      items.forEach((item) => item.classList.add('iwt-is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('iwt-is-visible');
        obs.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -12% 0px'
    });

    items.forEach((item, index) => {
      if (!item.style.getPropertyValue('--iwt-delay')) {
        item.style.setProperty('--iwt-delay', `${index * 90}ms`);
      }

      observer.observe(item);
    });
  });
})();
